module.exports = __webpack_public_path__ + "static/media/pendulumAlbumArt.01effb81.png";